import { Button } from '@/components/ui/elements/button';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

type ConnectionErrorStateProps = {
  title: string;
  description: string;
  onRetry: () => void;
  'data-testid'?: string;
};

// Calm, full-body "couldn't load" presentation shared by any call-center
// screen whose primary query fails with nothing cached to fall back on --
// first written for CallCenterDashboard, now shared with TeamView. A
// working Retry is the only recovery affordance; there is no auto-retry.
export const ConnectionErrorState = ({
  title,
  description,
  onRetry,
  'data-testid': testId,
}: ConnectionErrorStateProps) => (
  <div
    data-testid={testId}
    className="m-3 flex h-80 flex-col items-center justify-center gap-2 rounded border border-dashed text-center text-foreground/50"
  >
    <ExclamationTriangleIcon className="h-16 w-16" aria-hidden="true" />
    <p className="font-medium text-foreground/70">{title}</p>
    <p className="text-sm">{description}</p>
    <Button type="button" variant="outline" size="sm" onClick={onRetry}>
      Retry
    </Button>
  </div>
);
